import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"


import ListProjects from "./ListProjects.js"
import ViewProject from "./ViewProject.js"


import CreateProject from "./CreateProject.js"
import EditProject from "./EditProject.js"




export default function Projects() {

    return (
        <Routes>
            <Route path="/" element={<ListProjects />} />
            <Route path="/view/:id" element={<ViewProject />} />
            
            <Route path="/edit/:id" element={<EditProject />} />
            <Route path="/create/" element={<CreateProject />} />
        </Routes>
    )
}


